
import { Vue, Component, Prop } from 'vue-property-decorator';
import { FedExSecureCodeOption } from '../../types/fedexRegistration';

@Component
export default class FedExMfaOptionStep extends Vue {
  @Prop({ required: true }) secureCodeOptions!: FedExSecureCodeOption[];

  @Prop({ default: '' }) maskedEmail!: string;

  @Prop({ default: '' }) maskedPhoneNumber!: string;

  @Prop({ default: false }) loading!: boolean;

  private selectedOption: FedExSecureCodeOption | null = null;

  created(): void {
    if (this.secureCodeOptions.includes('SMS')) {
      this.selectedOption = 'SMS';
    }
  }

  get maskedHint(): string {
    if (!this.selectedOption) return '';

    if (this.selectedOption === 'EMAIL' && this.maskedEmail) {
      return this.maskedEmail;
    }

    if ((this.selectedOption === 'SMS' || this.selectedOption === 'CALL') && this.maskedPhoneNumber) {
      return this.maskedPhoneNumber;
    }

    return '';
  }

  private onSubmit(): void {
    if (!this.selectedOption) return;
    this.$emit('submit', this.selectedOption);
  }
}
